import { createErrorMessageTypeGuard } from '../createErrorMessageTypeGuard';
import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type IndividualSummaryDetail = {
   courses: IndividualSummaryDetailCourse[];
};

export type IndividualSummaryDetailCourse = {
   wikiid: number;
   course_assignmentid: number;
   title: string;
   description: string;
   completions: number;
   completionPercent: number;
   total: number;
   dueDate: number | null;
   completionStatus: string;
   assignmentUrl: string;
};

export async function getCourseAssignmentIndividualSummaryDetails(
   userid: number | null,
   common: CommonRequestOptions = {}
): Promise<IndividualSummaryDetail | null> {
   if (userid === null) return null;
   return makeRequest('get', `course_assignments/individualSummaries/${userid}`, common);
}

type GetCourseAssignmentIndividualSummaryDetailsErrorCode =
   'course_assignments.get_individual_summary_details_.user_not_found';

getCourseAssignmentIndividualSummaryDetails.errorMessages =
   createErrorMessageTypeGuard<GetCourseAssignmentIndividualSummaryDetailsErrorCode>();
